<template>
   
    <div>  

        <div v-if="tb.csstype&&tb.csstype=='a'">
            <label :for="tb.name" style="font-weight: normal;">
                <font style="color: red;" v-if="tb.ismust">*</font>
                <font style="color: red;" v-else="tb.ismust">&nbsp </font>
                {{tb.name}}
            </label>
            <div style="font-size:14px;opacity:0.5">{{tb.placeholder}}</div>
            <div class='ddcss' style="display: flex;align-items:center;width: 98%;">
                <!-- <input :type="tb.type?tb.type:'text'" v-model="tb.val" :id="'textbox'+tv" :name="'biaodan'+tv" 
                  @focus = 'picker'
                  style="width:100%;background-color: transparent;
               caret-color: rgb(148, 146, 146);padding: 3px;color:#313030"> -->
                <div style="width:100%;background-color: transparent;
               caret-color: rgb(148, 146, 146);padding: 3px;color:#313030;height: 25px;" @click='picker'>
                    {{tb.val}}
                </div>
                <i v-if="tb.val" @click="tb.val=''" class="weui-icon-clear"></i>
            </div>
        </div>


        <div v-else class="weui-cell" style="border-bottom: 1px solid rgba(0,0,0,0.1);"> 
            <div class="cell-hd" style="width:120px;padding-bottom: 5px;">           
                <font style="color: red;" v-if="tb.ismust">*</font>
                <font>{{tb.name}} </font>        
                    </div>       
            <div @click="picker" :style="{color:tb.val?'black':'rgb(161, 157, 157)'}" style="color:rgb(161, 157, 157);" class="cell-bd" >
                {{tb.val?tb.val:'请选择'+tb.name}}   
            </div>
            <a v-if="tb.val" @click="tb.val=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a> 
        </div>       
        


    </div>

</template>


<script>
export default{
props:['tb'],
methods:{
    picker(){
        weui.picker(this.tb.pickerdata, {
                defaultValue: ['text'],
                onChange: (result) => {
                    /* console.log(result); */

                },
                onConfirm: (result) => {
                    this.tb.val = result[0].label;
                                
                    let arr2 = [{"所属部门":"院领导","部门名称":"院领导"},{"所属部门":"第六部门工会","部门名称":"综合办公室"},{"所属部门":"第七部门工会","部门名称":"人力资源部"},{"所属部门":"第七部门工会","部门名称":"运财管理部"},{"所属部门":"第七部门工会","部门名称":"经营管理部"},{"所属部门":"第八部门工会","部门名称":"技术质量部"},{"所属部门":"第八部门工会","部门名称":"总师办公室"},{"所属部门":"第一部门工会","部门名称":"建筑设计一院"},{"所属部门":"第二部门工会","部门名称":"建筑设计二院"},{"所属部门":"第三部门工会","部门名称":"建筑设计三院"},{"所属部门":"第四部门工会","部门名称":"建筑设计四院"},{"所属部门":"第五部门工会","部门名称":"建筑设计五院"},{"所属部门":"第五部门工会","部门名称":"医疗康养及教育建筑设计院事业一部"},{"所属部门":"第六部门工会","部门名称":"专项建筑设计院商业地产研究设计中心"},{"所属部门":"第六部门工会","部门名称":"专项建筑设计院物流及产业园区建筑设计研究中心"},{"所属部门":"第六部门工会","部门名称":"专项建筑设计院专项工作一室"},{"所属部门":"第六部门工会","部门名称":"创作中心"},{"所属部门":"第八部门工会","部门名称":"技术研发中心BIM组"},{"所属部门":"第八部门工会","部门名称":"技术研发中心工业化组"},{"所属部门":"第八部门工会","部门名称":"项目管理中心"},{"所属部门":"第八部门工会","部门名称":"声学及剧院专项设计研究所"},{"所属部门":"第八部门工会","部门名称":"专项结构所"},{"所属部门":"第八部门工会","部门名称":"总师工作室"},{"所属部门":"第七部门工会","部门名称":"项目设计一部"},{"所属部门":"第七部门工会","部门名称":"项目设计二部"},{"所属部门":"第七部门工会","部门名称":"项目设计三部"},{"所属部门":"第七部门工会","部门名称":"项目设计四部"},{"所属部门":"第七部门工会","部门名称":"项目设计五部"},{"所属部门":"第七部门工会","部门名称":"项目设计六部"},{"所属部门":"第七部门工会","部门名称":"项目设计七部"},{"所属部门":"第七部门工会","部门名称":"项目设计八部"},{"所属部门":"第七部门工会","部门名称":"项目设计九部"},{"所属部门":"第七部门工会","部门名称":"项目设计十部"},{"所属部门":"第七部门工会","部门名称":"项目设计十一部"},{"所属部门":"第七部门工会","部门名称":"项目设计十二部"},{"所属部门":"第七部门工会","部门名称":"项目设计十六部"},{"所属部门":"第七部门工会","部门名称":"项目设计十七部"},{"所属部门":"第七部门工会","部门名称":"创作设计一部"},{"所属部门":"第七部门工会","部门名称":"创作设计二部"},{"所属部门":"第七部门工会","部门名称":"建筑产业设计研究部"},{"所属部门":"第八部门工会","部门名称":"雄安设计部"},{"所属部门":"第七部门工会","部门名称":"幕墙设计研究中心设计一部"},{"所属部门":"第七部门工会","部门名称":"幕墙设计研究中心设计二部"},{"所属部门":"第七部门工会","部门名称":"项目创作设计三部"},{"所属部门":"第六部门工会","部门名称":"专项建筑设计院专项工作二室"},{"所属部门":"第九部门工会","部门名称":"酒店建筑设计院"}];
                   let str = arr2.find(item=>item['部门名称']==this.tb.val).所属部门;
                    this.$store.state.bd.forEach(item=>{
                        if(item.id==5){
                            item.val = str;
                        }}
                       )
                },
                title: '请选择'+this.tb.name

            });
        }

    
}
}
</script>


<style>
.cell-hd{
padding-top: 16px;
display: flex;
align-items: center;
width:100px; 
}
.cell-bd{
padding-top: 16px;
display: flex;
align-items: center;
-webkit-box-flex: 1;
-webkit-flex: 1;
flex: 1;

}


.ddcss {
    border: solid 1px rgb(145, 141, 141)
}

.ddcss:focus-within {
    border: solid 1px rgb(133, 148, 212);
}
</style>


// WEBPACK FOOTER //
// src/fields/RadioTan.vue